import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 8h1v8","key":"svg-0"}],["path",{"d":"M7 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3","key":"svg-1"}]]

const IconNumber21Small = createReactComponent('outline', 'number-21-small', 'Number21Small', __iconNode);

export default IconNumber21Small;